<template>
  <bpb-form>
    <slot />
  </bpb-form>
</template>

<script>
export default {
  provide() {
    const shopContext = {};

    Object.defineProperty(shopContext, 'itemId', {
      enumerable: true,
      get: () => this.itemId,
    });

    Object.defineProperty(shopContext, 'amount', {
      enumerable: true,
      get: () => this.amount,
    });

    shopContext.setAmount = this.setAmount;

    return {
      shopContext,
    };
  },
  props: {
    itemId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      amount: undefined,
    };
  },
  methods: {
    setAmount(amount) {
      this.amount = amount;
    },
  },
};
</script>
